import * as tslib_1 from "tslib";
import setupFavoritePersona from './setupFavoritePersona';
import datapoints from '../../../datapoints';
import { getFavoritePersonasRootFolderId, retrievePersonaSearchFolders, } from 'owa-mail-persona-search-folder-services';
import { action } from 'satcheljs/lib/legacy';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import { getStore } from 'owa-mail-favorites-store';
export default action('initializeFavoritePersonas', datapoints.InitializeFavoritePersonasAction)(function initializeFavoritePersonas(personaIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var parentFolderId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFavoritePersonasRootFolderId()];
                case 1:
                    parentFolderId = _a.sent();
                    getStore().favoritePersonasRootFolderId = parentFolderId;
                    return [4 /*yield*/, setupPersonasSearchFolders(parentFolderId, personaIds)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
function setupPersonasSearchFolders(parentFolderId, personaIds) {
    return retrievePersonaSearchFolders(personaIds, parentFolderId)
        .then(function (personaSearchFolders) {
        personaSearchFolders.forEach(function (personaSearchFolder) {
            setupFavoritePersona(personaSearchFolder);
        });
    })
        .catch(function (error) {
        var _a = datapoints.RetrievePersonaSearchFoldersFailed.datapoint, eventName = _a.name, customData = _a.customData;
        trace.warn(eventName + ': ' + error);
        logUsage(eventName, customData(error.toString()));
    });
}
//# sourceMappingURL=initializeFavoritePersonas.js.map